import React, { Fragment } from 'react';

import { Grid, TextField } from '@mui/material';
import useTransformStore from '../../useTransformStore';
import ChipInput from '../../../ChipInput/ChipInput';

function RemoveEmptyValues({ onPlaceholderSelected, availablePlaceholders, listBelow, index }) {
  return (
    <Fragment>
      <Grid item xs={12} className="item-label">
        Remove all empty values from the list below
      </Grid>
      <Grid item xs={12} className="input-list-transform">
        <ChipInput
          onPlaceholderSelected={onPlaceholderSelected}
          placeholders={availablePlaceholders}
          fullWidth
          onBeforeAdd={chip => {
            useTransformStore.getState().setComponent(chip, index, 'listBelow');
            return true;
          }}
          placeholder="Insert a list "
          inputValue={listBelow}
          onDelete={indexChip => useTransformStore.getState().deleteChip(indexChip, index, 'listBelow')}
          onFocus={() => useTransformStore.getState().setFocus(index, 'listBelow')}
        />
      </Grid>
    </Fragment>
  );
}

export default RemoveEmptyValues;
